export default __webpack_public_path__ + "static/media/Charity.13d98038.png";